import { render, staticRenderFns } from "./prospect_all_list.vue?vue&type=template&id=5fd8a965&"
import script from "./prospect_all_list.vue?vue&type=script&lang=js&"
export * from "./prospect_all_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports